import * as actionTypes from '../actions/actionTypes'

const initialState = {
  loading: false,
  error: undefined,
  success: false,
  message: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
        success: false,
        message: '' // Reset message when request is made
      }
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        success: true,
        message: action.payload // Update message with success message payload
      }
    case actionTypes.FORGOT_PASSWORD_FAILURE:
      // Extract error message from the error object
      const errorMessage = action.payload && action.payload.message ? action.payload.message : 'Unknown error'
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        message: errorMessage
      }
    default:
      return state
  }
}
